import { render } from "./FacebookSigninButton.vue?vue&type=template&id=137a9243&scoped=true&ts=true"
import script from "./FacebookSigninButton.ts?vue&type=script&lang=ts&external"
export * from "./FacebookSigninButton.ts?vue&type=script&lang=ts&external"

import "./FacebookSigninButton.scss?vue&type=style&index=0&id=137a9243&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137a9243"]])

export default __exports__